import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from "@angular/common/http";
import { JwtHelperService, JwtModule } from "@auth0/angular-jwt";

import { HttpAuthComponent } from './http-auth.component';
import { HttpAuthService } from './http-auth.service';


@NgModule({
  declarations: [HttpAuthComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    JwtModule
  ],
  providers: [HttpAuthService, JwtHelperService],
  exports: [HttpAuthComponent, HttpClientModule, JwtModule]
})
export class HttpAuthModule { }
